/**
 * @author Angel Labrada
 * @since v0.0.1
 * @date 17/6/22
 */
import React, {createContext, useContext, useState} from 'react';

const AuditWizardContext = createContext({
  templateId: '',
  setTemplateId: val => val,
  templateCategories: [],
  setTemplateCategories: val => val,
  serviceId: '',
  setServiceId: val => val,
});

const useAuditWizard = () => {
  const context = useContext(AuditWizardContext);
  if (context === undefined) {
    throw new Error('useAuditWizard must be used within a AuditWizardProvider');
  }

  return context;
};

const AuditWizardProvider = ({ ...props }) => {

  const [templateId, setTemplateId] = useState('');
  const [templateCategories, setTemplateCategories] = useState([]);
  const [serviceId, setServiceId] = useState('');

  return (
    <AuditWizardContext.Provider
      value={{
        templateId,
        setTemplateId,
        templateCategories,
        setTemplateCategories,
        serviceId,
        setServiceId
      }}
      {...props}
    />
  );
};

export { useAuditWizard, AuditWizardProvider, AuditWizardContext };
